import axios from "axios";

const BASE_URL = "https://backre-miami.us-3.evennode.com";

// GET: Traer todos los deptos
export const getDeptos = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/deptos`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener deptos",
    };
  }
};

// GET: Traer un depto por ID
export const getDeptoById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/deptos/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener el depto",
    };
  }
};

// POST: Crear nuevo depto
export const postDepto = async (deptoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/deptos`;

  try {
    const resp = await axios.post(url, deptoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear depto",
    };
  }
};

// PUT: Actualizar depto
export const putDepto = async (id, deptoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/deptos/${id}`;

  try {
    const resp = await axios.put(url, deptoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar depto",
    };
  }
};

// DELETE: Desactivar depto
export const deleteDepto = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/deptos/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar depto",
    };
  }
};